import React from 'react';
import { StringColumn, CustomColumn } from 'baseui/data-table';
import { EMPTY_STRING } from 'commons-ui';
import _get from 'lodash/get';
import { STATUS_COLORS, LIST_COL_NAMES as COL_NAMES, STATUS_COL_NAMES as STAT_COL } from './constants';
import { getStatusColor } from './helper';

export const columnConfigs = [
	StringColumn({
		title: 'Requester Email',
		maxWidth: 250,
		mapDataToValue: (data: any) => {
			return String(_get(data, COL_NAMES.REQUESTER_EMAIL, EMPTY_STRING));
		}
	}),
	StringColumn({
		title: 'Description',
		maxWidth: 400,
		mapDataToValue: (data: any) => {
			return String(_get(data, COL_NAMES.DESCRIPTION, EMPTY_STRING));
		}
	}),
	StringColumn({
		title: 'Permission Type',
		maxWidth: 150,
		mapDataToValue: (data: any) => {
			return String(_get(data, COL_NAMES.PERMISSION_TYPE, EMPTY_STRING));
		}
	}),
	CustomColumn({
		title: 'Status',
		maxWidth: 120,
		mapDataToValue: (data: any) => ({
			status: String(_get(data, COL_NAMES.STATUS, EMPTY_STRING))
		}),
		renderCell: (params: any) => {
			const { value } = params;
			return <span style={{ color: getStatusColor(value.status, STATUS_COLORS), fontWeight: 'bold' }}>{value.status}</span>;
		}
	}),
	StringColumn({
		title: 'Created At',
		maxWidth: 180,
		mapDataToValue: (data: any) => {
			const date = _get(data, COL_NAMES.CREATED_AT);
			return date ? new Date(date).toLocaleString() : EMPTY_STRING;
		}
	}),
	StringColumn({
		title: 'Total Rows',
		maxWidth: 120,
		mapDataToValue: (data: any) => {
			return String(_get(data, COL_NAMES.TOTAL_ROWS, EMPTY_STRING));
		}
	}),
	StringColumn({
		title: 'Success Count',
		maxWidth: 120,
		mapDataToValue: (data: any) => {
			return String(_get(data, COL_NAMES.SUCCESS_COUNT, EMPTY_STRING));
		}
	}),
	StringColumn({
		title: 'Failure Count',
		maxWidth: 120,
		mapDataToValue: (data: any) => {
			return String(_get(data, COL_NAMES.FAILURE_COUNT, EMPTY_STRING));
		}
	})
];

export const statusColumnConfigs = [
	StringColumn({
		title: 'User Email',
		maxWidth: 200,
		mapDataToValue: (data: any) => {
			return String(_get(data, STAT_COL.USER_EMAIL, EMPTY_STRING));
		}
	}),
	StringColumn({
		title: 'Permission',
		maxWidth: 400,
		mapDataToValue: (data: any) => {
			return String(_get(data, STAT_COL.PERMISSION, EMPTY_STRING));
		}
	}),
	StringColumn({
		title: 'Action',
		maxWidth: 100,
		mapDataToValue: (data: any) => {
			return String(_get(data, STAT_COL.ACTION, EMPTY_STRING));
		}
	}),
	CustomColumn({
		title: 'Status',
		maxWidth: 100,
		mapDataToValue: (data: any) => ({
			status: String(_get(data, STAT_COL.STATUS, EMPTY_STRING))
		}),
		renderCell: (params: any) => {
			const { value } = params;
			return <span style={{ color: getStatusColor(value.status, STATUS_COLORS), fontWeight: 'bold' }}>{value.status}</span>;
		}
	}),
	StringColumn({
		title: 'Processed At',
		maxWidth: 180,
		mapDataToValue: (data: any) => {
			const date = _get(data, STAT_COL.PROCESSED_AT);
			return date ? new Date(date).toLocaleString() : '-';
		}
	}),
	CustomColumn({
		title: 'Remarks',
		maxWidth: 220,
		mapDataToValue: (data: any) => {
			return String(_get(data, STAT_COL.REMARK, '-'));
		},
		renderCell: ({ value }) => (
			<span title={value} style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
				{value}
			</span>
		)
	})
];
